export const WORKDAY_STATUS = Object.freeze({
    WORKDAY_STARTED: "Workday_Started",
    WORKDAY_STOPPED: "Workday_Stopped",
});

export const SHIFT_STATUS = Object.freeze({
    SHIFT_IN: "Shift_In",
    SHIFT_OUT: "Shift_Out",
    SHIFT_PAUSED: "Shift_Pause",
    SHIFT_RESUMED: "Shift_Resume",
    SHIFT_PAUSED_UNREACHABLE: "Shift_Pause_Unreachable",
    SHIFT_PAUSED_INACTIVE: "Shift_Pause_InActive",
});

export const OFFICE_HOUR_STATUS = Object.freeze({
    OFFICE_OPEN: "Office_Open",
    OFFICE_CLOSE: "Office_Close",
    PAST_OFFICE_HOURS: "Past_Office_Hours",
});
